import { defineStore } from 'pinia'

export const useQuestionnaireStore = defineStore({
  id: 'questionnaireStore',
  state: () => ({
    formData: {} as Record<string, any>
  }),
  actions: {
    updateFormData(fieldId: string, value: any) {
      this.formData[fieldId] = value
    },
    setFormData(data: Record<string, any>) {
      this.formData = data
    }
  }
})
